import React, { useState } from 'react'
import { Select, Input, Empty, message, Spin } from 'antd'
import { debounce } from 'lodash'
import { provinceProductsApi, ProvinceProductModels } from '@getgreenline/products'
import { ProvinceProductsList } from './ProvinceProductsList'
import { ProvinceProductsHeader } from './ProvinceProductsHeader'
import { CANProvinces } from '@getgreenline/companies'

export function ProvinceProductsSearch() {
  const [isLoading, setIsLoading] = useState(false)
  const [province, setProvince] = useState(CANProvinces.AB)
  const [searchProducts, setSearchProducts] = useState<
    ProvinceProductModels.IProvinceProductContract[]
  >([])

  const getProducts = async (searchQuery: string) => {
    setIsLoading(true)

    try {
      const productsResponse = await provinceProductsApi.getProvinceProducts(province, searchQuery)

      setSearchProducts(productsResponse)
    } catch (err) {
      message.error('Failed to load')
    } finally {
      setIsLoading(false)
    }
  }

  const onInputChange = debounce(async (value: string) => {
    if (value.length === 0) {
      setSearchProducts([])
      return
    }

    await getProducts(value)
  }, 500)

  return (
    <>
      <ProvinceProductsHeader />
      <div className='row'>
        <div className='col-xs-12 col-lg-6 offset-lg-3'>
          <Input
            key='search'
            addonAfter={
              <Select<CANProvinces>
                className='select-after'
                defaultValue={CANProvinces.AB}
                onChange={(value) => setProvince(value)}
              >
                <Select.Option value={CANProvinces.AB}>{CANProvinces.AB}</Select.Option>
                <Select.Option value={CANProvinces.BC}>{CANProvinces.BC}</Select.Option>
                <Select.Option value={CANProvinces.ON}>{CANProvinces.ON}</Select.Option>

                {Object.keys(CANProvinces).map((key) => {
                  const province: CANProvinces = CANProvinces[key]
                  const hasCatalogue = [CANProvinces.AB, CANProvinces.BC, CANProvinces.ON].includes(
                    province,
                  )

                  if (hasCatalogue) return

                  return (
                    <Select.Option key={province} value={province}>
                      {province}
                    </Select.Option>
                  )
                })}
              </Select>
            }
            className='ml-3 mr-3'
            placeholder='Search by SKU, name, barcode, or vendor'
            onChange={(e) => onInputChange(e.target.value)}
          />

          {isLoading ? (
            <div className='mt-3 offset-lg-6'>
              <Spin />
            </div>
          ) : (
            <div className='mt-3'>
              {searchProducts.length > 0 ? (
                <div className='ml-3 mr-3'>
                  <ProvinceProductsList title='Search results' productsToAdd={searchProducts} />
                </div>
              ) : (
                <Empty />
              )}
            </div>
          )}
        </div>
      </div>
    </>
  )
}
